import { render, staticRenderFns } from "./objDialog.vue?vue&type=template&id=6edc6eea&scoped=true"
import script from "./objDialog.vue?vue&type=script&lang=js"
export * from "./objDialog.vue?vue&type=script&lang=js"
import style0 from "./objDialog.vue?vue&type=style&index=0&id=6edc6eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc6eea",
  null
  
)

export default component.exports